import { DateTime } from "luxon";
import { ClientPhase } from "../Client/types";
import { ObserverPhase } from "./GeneratedTypes";

const util = {
    format: function (s: string, placeholders: any): string {
        for (var propertyName in placeholders) {
            var re = new RegExp("{" + propertyName + "}", "gm");
            s = s.replace(re, placeholders[propertyName]);
        }
        return s;
    },
    getExtObserverCookie: function (sessionId: string) : string {
        var name = "ExternalObserverSession_" + sessionId + "=";
        var decodedCookie = decodeURIComponent(document.cookie);
        var ca = decodedCookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    },
    createExtObserverCookie: function (cookie: string, sessionId: string ) : string {
        var d = new Date();
        d.setTime(d.getTime() + (1 * 24 * 60 * 60 * 1000));
        var expires = "expires=" + d.toUTCString();
        document.cookie = "ExternalObserverSession_" + sessionId + "=" + cookie + ";" + expires + ";path=/";
        return this.getExtObserverCookie(sessionId);
    },
    updateExtCookieOnPhase: function (cookie: string, sessionId: string, phase: ObserverPhase, acceptedPrivacyStatement?: Date): string {
        var cookieObject = JSON.parse(cookie);
        //update contents of object, update cookie, then return new cookie string
        cookieObject.currentPhase = phase;
        cookieObject.acceptedPrivacyStatement = acceptedPrivacyStatement;
        
        return this.createExtObserverCookie(JSON.stringify(cookieObject), sessionId);
    },
    deleteObserverCookie: function (sessionId: string): void {
        var name = "ExternalObserverSession_" + sessionId;
        document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:01 GMT;Path=/;';
    }

};

export default util;
